import { useContextSelector } from 'use-context-selector';

import type { BoardMembersContextValue } from './BoardMembersContext';
import { BoardMembersContext } from './BoardMembersContext';

/**
 * Access the BoardMembersContext with a context selector to access a specific
 * nested value. This allows consumers to only subscribe to updates on the
 * selected value.
 *
 * @example
 * // Only subscribe to cards associated with the given list ID:
 * const isDeactivated = useBoardMembersContext(
 *   useCallback(({ deactivatedIds }) => deactivatedIds?.has(memberId), [memberId]),
 * );
 */
export const useBoardMembersContext = <T>(
  selector: (value: BoardMembersContextValue) => T,
) => useContextSelector(BoardMembersContext, selector);
